import * as t from 'io-ts';
import { isRight } from 'fp-ts/Either';

// Function to create a codec for non-empty arrays of a configurable type
const nonEmptyArray = <C extends t.Mixed>(codec: C) => {
    const ArrayCodec = t.array(codec);
    return new t.Type<Array<t.TypeOf<C>>, Array<t.TypeOf<C>>, unknown>(
        `NonEmptyArray<${codec.name}>`,
        (u): u is Array<t.TypeOf<C>> => Array.isArray(u) && u.length > 0 && u.every(item => codec.is(item)),
        (u, c) => {
        const validation = ArrayCodec.validate(u, c);
        if (isRight(validation) && validation.right.length > 0) {
            console.log('validation.right', validation.right);
            return t.success(validation.right);
        } else {
            return t.failure(u, c);
        }
        },
        t.identity
    );
};

export default nonEmptyArray;